// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hi {
  height: calc(100vh - 196px);
  transition: ease 0.1s;
}

.lo {
  height: calc(100vh - 360px);
  transition: ease 0.25s;
}

.orangeBorder {
  border-left: 3px solid orange !important;
  cursor: not-allowed !important;
}

.redBorder {
  border-left: 3px solid red !important;
  cursor: pointer !important;
}

.noBorder {
  border-left: none !important;
  cursor: pointer !important;
}`, "",{"version":3,"sources":["webpack://./src/app/common/correspondence/email-list/email-list.component.scss"],"names":[],"mappings":"AAMA;EACI,2BAAA;EACA,qBAAA;AALJ;;AAQE;EACE,2BAAA;EACA,sBAAA;AALJ;;AAQE;EACE,wCAAA;EACA,8BAAA;AALJ;;AAQE;EACE,qCAAA;EACA,0BAAA;AALJ;;AAQE;EACE,4BAAA;EACA,0BAAA;AALJ","sourcesContent":["// .emailNotificatios-block-css {\r\n//   width: 100%;\r\n//   height: calc(100vh - 254px);\r\n//   overflow: auto;\r\n// }\r\n\r\n.hi {\r\n    height: calc(100vh - 196px);\r\n    transition: ease 0.1s;\r\n  }\r\n  \r\n  .lo {\r\n    height: calc(100vh - 360px);\r\n    transition: ease 0.25s;\r\n  }\r\n  \r\n  .orangeBorder{\r\n    border-left: 3px solid orange !important;\r\n    cursor: not-allowed !important;\r\n  }\r\n  \r\n  .redBorder{\r\n    border-left: 3px solid red !important;\r\n    cursor: pointer !important;\r\n  }\r\n  \r\n  .noBorder{\r\n    border-left: none !important;\r\n    cursor: pointer !important;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
